<div class="p-fluid">
  <div class="field">
    <label class="font-medium required-field">Помещение</label>
    <crm-room-single-select
      [customRequest]="true"
      [rooms]="rooms"
      [(selectedRoom)]="selectedRoom"
      appendTo="body"></crm-room-single-select>
  </div>
</div>

<button
  pButton
  label="Пропустить ТС"
  [disabled]="!selectedRoom"
  icon="pi pi-check"
  class="p-button-success"
  (click)="approve()"></button>
